import { useState, ReactNode } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import parse from 'html-react-parser';

interface AccordionItem {
  title: string;
  content: string | ReactNode;
}

interface AccordionProps {
  items?: AccordionItem[];
}

function Accordion({ items = [] }: AccordionProps): JSX.Element {
  const [openIndex, setOpenIndex] = useState<number>(0);


  const accordionItems = items;

  const toggleItem = (index: number): void => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <>
      {accordionItems.map((item, index) => (
        <div key={index} className="bg-[#AEDEDA]/10 rounded-2xl mb-4 md:p-8 p-2 w-full lg:max-w-[71.5rem]  max-w-lg border border-gray-200">

          <div className="border-b border-gray-200 last:border-b-0">
            <button
              className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              onClick={() => toggleItem(index)}
            >
              <span className="font-semibold text-xl text-gray-900">{item.title}</span>
              {openIndex === index ? (
                <ChevronUp className="w-5 h-5 " />
              ) : (
                <ChevronDown className="w-5 h-5" />
              )}
            </button>
            {openIndex === index && openIndex >= 0 && (
              <div className="md:px-7 px-4 pb-4">
                <div className="text-gray-900 text-[16px] prose prose-sm max-w-none">
                  {typeof item.content === 'string' ? parse(item.content) : item.content}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
}

export default Accordion; 